import { AlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { ListingApplicationPayload } from 'api/ats';
import { CmsApiSubscribe } from 'modules/cms/api/types/CmsApiSubscribe';
import { SalariesReportFormData } from 'modules/salaries/types/SalariesReportFormData';

import { postJson } from './http';

type TmpListingApplicationPayload = {
  initialValues: ListingApplicationPayload;
};
type SavedSearchUnsaved = {
  savedSearch: {
    text: string;
    filters: AlgoliaApiQueryFilters;
    location: SearchLocation;
    radius: number | null;
    index: 'MAIN' | 'ACTIONS';
  };
};
type SignupBlockRedirect = {
  redirectUrl: string;
};

export type SaveListingType = {
  listing: {
    id: string;
    type: string;
    name: string;
  };
};

export type SubscribeSubsiteType = {
  subscribedSubsiteId: string;
};

export type SurveyReportDataType = {
  surveyReport: {
    initialValues: SalariesReportFormData;
  };
};

export type StateType =
  | object
  | TmpListingApplicationPayload
  | SavedSearchUnsaved
  | CmsApiSubscribe
  | SignupBlockRedirect
  | SaveListingType
  | SubscribeSubsiteType
  | SurveyReportDataType;

export type ActionType =
  | 'CMS_SUBSCRIBE'
  | 'SURVEY_REPORT_DATA'
  | 'LISTING_APPLICATION_VALUES'
  | 'SAVE_SEARCH'
  | 'SAVE_LISTING'
  | 'SIGNUP_BLOCK_REDIRECT'
  | 'SUBSCRIBE_SUBSITE';

type ListingApplicationValuesAction = {
  type: 'LISTING_APPLICATION_VALUES';
  data: TmpListingApplicationPayload;
};

type SaveSearchAction = {
  type: 'SAVE_SEARCH';
  data: SavedSearchUnsaved;
};

type CmsSubscribeAction = {
  type: 'CMS_SUBSCRIBE';
  data: CmsApiSubscribe;
};

type SignupBlockRedirectAction = {
  type: 'SIGNUP_BLOCK_REDIRECT';
  data: SignupBlockRedirect;
};

type SaveListingAction = {
  type: 'SAVE_LISTING';
  data: SaveListingType;
};

type SusbscribeSubsiteAction = {
  type: 'SUBSCRIBE_SUBSITE';
  data: SubscribeSubsiteType;
};

type SurveyReportDataAction = {
  type: 'SURVEY_REPORT_DATA';
  data: SurveyReportDataType;
};

export type Action =
  | ListingApplicationValuesAction
  | SaveSearchAction
  | CmsSubscribeAction
  | SignupBlockRedirectAction
  | SaveListingAction
  | SusbscribeSubsiteAction
  | SurveyReportDataAction;

function mapStateToTemporaryStorage<T>(
  state: Partial<Record<ActionType, T>>,
): Array<{
  type: ActionType;
  data: T;
}> {
  // @ts-expect-error TS(2322): Type '{ type: ActionType; data: T | undefined; }[]... Remove this comment to see the full error message
  return Object.keys(state).map((key: ActionType) => ({
    type: key,
    data: state[key],
  }));
}

type PayloadType = {
  listing?:
    | {
        id: string;
        type: string;
        name: string;
      }
    | null
    | undefined;
  subscribedSubsiteId?: string | null | undefined;
};

export function saveTemporaryStorage<T>(state: Partial<Record<ActionType, T>>) {
  return postJson<{ data: { id: string } }>('/data/tmp-storage', {
    data: JSON.stringify(mapStateToTemporaryStorage(state)),
  }).then(({ data: { id } }) => id);
}

export async function saveTemporaryStorageAndGenerateRedirectURL(
  redirectTo: string | null | undefined,
  payload: PayloadType,
) {
  let id = null;

  if (Object.values(payload).filter(Boolean).length > 0) {
    const data = {};

    if (payload.listing) {
      // @ts-expect-error TS(2339): Property 'SAVE_LISTING' does not exist on type '{}... Remove this comment to see the full error message
      data.SAVE_LISTING = {
        listing: payload.listing,
      };
    }

    if (payload.subscribedSubsiteId) {
      // @ts-expect-error TS(2339): Property 'SUBSCRIBE_SUBSITE' does not exist on typ... Remove this comment to see the full error message
      data.SUBSCRIBE_SUBSITE = {
        subscribedSubsiteId: payload.subscribedSubsiteId,
      };
    }

    id = await saveTemporaryStorage(data);
  }

  if (redirectTo) {
    const param = redirectTo.includes('?') ? '&tmpId' : '?tmpId';
    return id ? `${redirectTo}${param}=${id}` : redirectTo;
  }

  if (id && window) {
    const url = `${window.location.pathname}${window.location.search}`;
    const param = url.includes('?') ? '&tmpId' : '?tmpId';
    return id ? `${url}${param}=${id}` : redirectTo;
  }

  return null;
}
